"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var title = {
    fontFamily: 'BentonSansMedium-Regular, Arial, Helvetica, sans-serif',
    color: widgets_1.TabStyles.Colors.F9,
    height: '16px',
};
exports.title = title;
var titleSpan = {
    display: 'inline-flex',
    alignItems: 'center',
};
exports.titleSpan = titleSpan;
var permissions = {
    marginTop: widgets_1.TabStyles.Spacing.MediumSpace,
    marginBottom: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    color: widgets_1.TabStyles.Colors.F9,
    fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
};
exports.permissions = permissions;
var icon = {
    marginRight: widgets_1.TabStyles.Spacing.DefaultSpace,
    overflow: 'initial',
};
exports.icon = icon;
var contentName = {
    fontWeight: 'bold',
};
exports.contentName = contentName;
var shareDialog = {
    color: widgets_1.TabStyles.Typography.Color.Primary,
    marginBottom: '-2px',
};
exports.shareDialog = shareDialog;
var spinnerContainer = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
};
exports.spinnerContainer = spinnerContainer;
var spinnerLabel = {
    marginTop: widgets_1.TabStyles.Spacing.DefaultSpace,
};
exports.spinnerLabel = spinnerLabel;
var footerButtonsContainer = {
    float: 'right',
    marginTop: widgets_1.TabStyles.Spacing.DefaultSpace,
};
exports.footerButtonsContainer = footerButtonsContainer;
//# sourceMappingURL=ShareDialogStyle.js.map